import { selectSalesIntelligenceState } from "app/pages/sales-intelligence/store/selectors";
import { createStatePropertySelector } from "app/pages/workspace/sales/helpers";
import { createSelector } from "reselect";

export const selectManagementReducer = createStatePropertySelector(selectSalesIntelligenceState("management"));

const selectManageIntegrationModalState = selectManagementReducer("manageIntegrationModal");
const selectIntegrationModalReducer = createStatePropertySelector(selectManageIntegrationModalState);

const selectTogglesModalReducer = selectIntegrationModalReducer("togglesModal");

export const selectModalNotification = createSelector(selectTogglesModalReducer, (state) => state.isOpen);

export const selectModalToggleName = createSelector(selectTogglesModalReducer, (state) => state.toggleName);

export const selectIsDisabledIntegrationModal = createSelector(
    selectTogglesModalReducer,
    (toggle) => toggle?.isDisabled,
);

export const selectIsMissingMandatoryFieldsModalOpen = createSelector(
    selectManageIntegrationModalState,
    (state) => state.isMissingMandatoryFieldsModalOpen,
);
